import React from "react";
import "../../component/styles/styles.scss";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { mixColors } from "../../component/data/data";
import { Usesolidcolorcontext } from '../../utils/Hooks';
import tinycolor from 'tinycolor2';

const Mixcolorpalette = () => {
  const { handleMixColor, copy } = Usesolidcolorcontext();

  const generateColorShades = (colorHexCode) => {
    const color = tinycolor(colorHexCode);
    const shades = [];

    // Generate shades using tinycolor2
    for (let i = 0; i <= 5; i++) {
      const shade = color.darken(i * 3).saturate(1 * 3).toString();
      shades.push(shade);
    }

    return shades;
  };


  return (
    <div className="red-color-pallete-wrapper" id="mix-color-pallete-wrapper">
      <h2>Mix Shades</h2>
      <Row>
        {mixColors.map((getBgColor, i) => {
          const shades = generateColorShades(getBgColor.mixColorsHexCode);
          return (
            <Col md="3" key={i}>
              <div
                className="redColor-wrapper"
              >
                {shades.map((shade, index) => (
                  <div
                    className="color-shade"
                    key={index}
                    style={{ backgroundColor: shade }}
                    onClick={() => handleMixColor(shade)}
                  >
                    {copy === shade ? <h5>Copied!</h5> : ""}
                    <p>{shade}</p>
                  </div>
                ))}
                 <p className="text-for-color-name">{getBgColor.colorName}</p>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};
export default Mixcolorpalette;
